export default [
  {
    path: 'afiliados/instalacoess',
    name: 'instalacoess',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Instalações',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Instalações' },
      ]
    }
  },
]